import { ConditionType } from '@app/core/models/enums/condition-type.enum';

/**
 * Marks an entry from GET /api.php/taxonomy as a Taxonomy Service active version rather than a
 * legacy taxonomy-database row. Set by the platform when it appends TaaS entries to that listing.
 */
export const TAXONOMY_SERVICE_SOURCE: string = 'taxonomy_service';

/**
 * Prefix on GET /api.php/taxonomy `client` values (`taxonomy_service:{key}:{version}`).
 * exports.taxonomy_service_keys stores `{key}:{version}` without this prefix.
 */
export const TAXONOMY_SERVICE_CLIENT_PREFIX: string = `${TAXONOMY_SERVICE_SOURCE}:`;

/**
 * Label within exports.taxonomy_service_keys identifying the destination's own taxonomy, as opposed
 * to best_practices. Mirrors the platform-side TaxonomyServiceKeys::CHANNEL_LABEL.
 */
export const TAXONOMY_CHANNEL_KEY_LABEL: string = 'channel';

/**
 * Label TaaS and the platform use for attributes that apply to every category. The missing-fields
 * matrix collapses those onto one row with this name rather than repeating them on every category.
 */
export const MISSING_FIELDS_ALL_CATEGORIES_LABEL: string = 'All categories';

/**
 * Conditions selected by default in the Add missing fields drawer and in the Conditions & categories
 * dropdown: required, conditionally required (in the drawer, only when the taxonomy returns it) and
 * recommended. Optional is deliberately excluded.
 */
export const DEFAULT_SELECTED_CONDITIONS: ConditionType[] = [
    ConditionType.REQUIRED,
    ConditionType.CONDITIONALLY_REQUIRED,
    ConditionType.RECOMMENDED
];

/** Shown when a gate reason code is absent, or one this build does not recognise yet. */
export const MISSING_FIELDS_GATE_FALLBACK_COPY: string = 'Missing fields can\'t be loaded for this export.';

/**
 * Prefix on eBay item-specific export field names. The taxonomy service sends the bare attribute key,
 * so an export field named `itemSpecific_Brand` satisfies the attribute `Brand`.
 */
export const ITEM_SPECIFIC_FIELD_PREFIX: string = 'itemSpecific_';

/** First data column in the Add missing fields drawer: attribute name plus category breadcrumb. */
export const MISSING_FIELDS_CATEGORY_PATH_COLUMN_HEADER: string = 'Category & path';

/**
 * Upper bound on category values sent to the taxonomy service in one request; the API rejects more.
 * Shared with the spec so the production cap and the assertion cannot drift apart.
 */
export const MAX_CATEGORY_VALUES: number = 1000;
